
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DevIcon',

  props: {
    name: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      default: '',
    },
    to: {
      type: Object,
      default: undefined,
    },
  },
})
